import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { SinglePlayer } from '../../../Api/Players/models';
import { patchPlayer } from '../../../Api/Players/Players';

interface EditPlayerModalProps {
    show: boolean;
    onHide: () => void;
    player: SinglePlayer | null;
}

export const EditPasswordModal = ({ show, onHide, player }: EditPlayerModalProps) => {
    const [form, setForm] = useState<any>({
        newPassword: '',
    });

    const handleSubmit = async () => {
        const payload = {
            id: player?.id || '',
            newPassword: form.newPassword,
        }
        const res = await patchPlayer(payload)
        if (res?.success) {
            onHide();
        }
    };

    return (<>
        <Modal show={show} onHide={onHide} centered keyboard={false}>
            <div className="border border-primary rounded-3 shadow-lg">
                <Modal.Header closeButton>
                    <Modal.Title>Cambiar contraseña {player?.platformUser}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicHourLimit">
                            <Form.Label>Ingresa una nueva contraseña para el jugador {player?.platformUser}</Form.Label>
                            <Form.Control type="text" placeholder="Ingrese la nueva contraseña" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-between w-100'>
                        <Button variant="secondary" onClick={onHide}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </div>
                </Modal.Footer>
            </div>
        </Modal>
    </>

    );
};
